var _defs, _path, _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico_message",
    "data-name": "ico message",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.406,
    height: 24.406,
    viewBox: "0 0 24.406 24.406",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .blueMessage {\r\n        fill: #0b5386;\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_2_copy_8",
    "data-name": "Ellipse 2 copy 8",
    className: "blueMessage",
    d: "M359.8,336.205a12.217,12.217,0,1,1-12.2,12.216A12.206,12.206,0,0,1,359.8,336.205Z",
    transform: "translate(-347.594 -336.219)"
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "message-2_copy_5",
    "data-name": "message-2 copy 5",
    x: 4.406,
    y: 5.781,
    width: 16,
    height: 15,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAPCAYAAADtc08vAAABGElEQVQokZXTzypFURgF8J/bZWBCmcjgDv0pipE5Y255AcXIU4gH8QYMKKXcB1CGpAyN3ORfMSE+be1Tt+Oce7Pqq2/vvdba3z6tMxQRMIwtrGJEf3yggwN8iohGRJzG/5E0jWTQztJORLTSRAOqlbkJ7SaW8sD7uMMaJmoe8YiTzF1J2mbP4SumcTzgG8xk7i+apcNbrA+YIHEW6wwSzjBa2vvEe5Vjo7SewhOeS/WG7SqDZql/wSHGSrxvXFfpUtPNfRuX2Ky6qYR2XnZTEsdxg0lc4D6/eQ9XmTiP3ZzYxFvOvLkiNLMRcR4RXz15fIiIhVypL5A4iZs06lK302NSiNPeH26/2BYmteJUxd9Yh418cFRJwA9GtUHrGDnwSgAAAABJRU5ErkJggg=="
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMessage);
export default __webpack_public_path__ + "static/media/ico_message.cbc1234b.svg";
export { ForwardRef as ReactComponent };